import { useState } from "react";
import { DataProvider, IErrorModel, IPaymentInvoiceModel } from "@nf/common";

export const useDownloadInvoicePDF = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<IErrorModel | undefined>();

  const download = async (invoice: IPaymentInvoiceModel) => {
    setIsLoading(true);
    setError(undefined);

    try {
      const pdf = await DataProvider.getInvoicePDF(invoice.Id);
      const url = URL.createObjectURL(pdf);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${invoice.Number}.pdf`;
      link.click();
      // Revoking synchronously can cancel the download in Safari
      setTimeout(() => URL.revokeObjectURL(url));
    } catch (error) {
      setError(error as IErrorModel);
    } finally {
      setIsLoading(false);
    }
  };

  return { download, isLoading, error };
};
